import React from 'react'

import "./table.scss";
import { useEffect as uEffect, useState as uState } from "react";

export default function latestProduct() {

    const [allProduct, setAllProduct] = uState([]);
    uEffect(() => {
        async function fetchData() {
            const response = await fetch('http://localhost:8000/products/allProduct',
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                }
            );
            const data = await response.json();
            setAllProduct(data);
        }
        fetchData();
    }, [])
    return (
        <>
            <table className="table">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Id</th>
                        <th scope="col">Type</th>
                        <th scope="col">Product</th>
                        <th scope="col">Description</th>
                        <th scope="col">Amount</th>
                    </tr>
                </thead>
                {allProduct.slice().reverse().map((product, index) => (
                    <tbody key={index}>
                        <React.Fragment >
                                <tr>
                                    <td>{index + 1}</td>
                                    <td>{product._id}</td>
                                    <td>{product.productType}</td>
                                <td className='cellWrapper'>
                                    {/* {product.imageUrl ? (
                                        <img className='image' src={`http://localhost:8000/public/${product.imageUrl}`} alt="" />
                                    ) : (
                                            <img className='image' src={`${product.productImage}`} alt="" />
                                    )} */}
                                    <img className='image' src={`http://localhost:8000/public/images/${product.productImage}`}  alt="" />
                                    {product.productTitle}
                                </td>
                                <td>{product.productDescription}</td>                                
                                    <td>₹{product.productAmount}</td>
                                </tr>
                        </React.Fragment>
                    </tbody>
                ))}

            </table>
        </>
    )
}

